
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ShuffleMaps/Favorites",
      function () {
        return require("private-next-pages/ShuffleMaps/Favorites.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ShuffleMaps/Favorites"])
      });
    }
  